import { useContext } from 'react';

import { PollingContext } from './PollingContextProvider';
import useSubscribeToPollingContext from './useSubscribeToPollingContext';
import type { PollingContextSubscriptionPayload } from './withPollingContextSubscription';

export default function usePollingContextSubscription({
  startActions,
  stopActions,
}: PollingContextSubscriptionPayload) {
  const {
    subscriptions: { registerSubscription, unregisterSubscription },
  } = useContext(PollingContext);

  useSubscribeToPollingContext({ startActions, stopActions, registerSubscription, unregisterSubscription });
}
